import { CheckboxInputGroup } from '../input-group/checkbox-input-group';
import type { SearchConditions } from '~/types/search-conditions';
import type { MasterData } from '~/types/master-data';

interface TypeFormProps {
  masterData: MasterData;
  searchConditions: SearchConditions;
  updateChecked: (
    type: keyof SearchConditions,
    name: string,
    checked: boolean,
  ) => void;
}

export function TypeForm(props: TypeFormProps) {
  return (
    <div className="md:px-4 pb-4 border-b">
      <div className="p-side-search-form__section__title -type">工事の種類</div>
      <div className="mt-1 md:mt-0 flex flex-wrap gap-4">
        {props.masterData.types?.map((item) => (
          <CheckboxInputGroup
            key={`type-${item.id}`}
            id={`type-${item.id}`}
            name="jobs_search[type_names][]"
            value={item.name}
            label={item.name}
            checked={props.searchConditions.typeNames.includes(item.name)}
            updateChecked={(checked: boolean) =>
              props.updateChecked('typeNames', item.name, checked)
            }
          />
        ))}
      </div>
    </div>
  );
}
